/**
 * What an inbox email's FAQ can be saved to, and the FAQ text limits.
 * Shared by the Add to FAQ dialog and the server; no server code here.
 */

export const FAQ_TARGET_KINDS = [
  "venue",
  "show",
  "add_on",
  "shop_item",
] as const;
export type FaqTargetKind = (typeof FAQ_TARGET_KINDS)[number];

export type FaqTargetOption = { id: number; name: string };

/** One venue's languages, and what its FAQ can be saved to besides the venue. */
export type FaqTargets = {
  /** The languages the venue is written in; a FAQ is saved in each filled. */
  languages: string[];
  shows: FaqTargetOption[];
  addOns: FaqTargetOption[];
  shopItems: FaqTargetOption[];
};

/** The same limits as the FAQ dialogs. */
export const FAQ_QUESTION_LIMIT = 500;
export const FAQ_ANSWER_LIMIT = 5000;
